.category-tile-content{width:70px;border-radius:5px;padding-top:2px;padding-bottom:2px;text-align:center}
/*# sourceMappingURL=category-tile.component-HSGDW2AZ.css.map */
